<template>
  <van-tabbar
      v-model="tabbarIndex"
      safe-area-inset-bottom
      :border="false"
      inactive-color="#fff"
      z-index="99"
      :fixed="false"
  >
    <van-tabbar-item to="/" name="home">
      <img slot="icon" slot-scope="props" :src="props.active ? icon_nav1.active : icon_nav1.normal" style="width: 25px;height: 25px;">
      {{$t('home.tabBar[0]')}}
    </van-tabbar-item>
         <!-- <van-tabbar-item to="/user/teamReport" name="teamReport">
      <img slot="icon" slot-scope="props" :src="props.active ? icon_nav2.active : icon_nav2.normal" style="width: 25px;height: 25px;" />
      {{$t('home.tabBar[1]')}}
    </van-tabbar-item> -->
	<van-tabbar-item to="/myTask" name="task">
	  <img slot="icon" slot-scope="props" :src="props.active ? icon_nav2.active : icon_nav2.normal" style="width: 25px;height: 25px;" />
	  {{$t('home.tabBar[1]')}}
	</van-tabbar-item>
    <van-tabbar-item class="vip" to="/T" name="T" style="z-index: 999;">
      <img slot="icon" slot-scope="props" :src="props.active ? icon_nav4.active : icon_nav4.normal" style="width: 80px;height: 80px;" />
      <!-- {{$t('home.tabBar[2]')}} -->
    </van-tabbar-item>
     <van-tabbar-item to="/map" name="map">
      <img slot="icon" slot-scope="props" :src="props.active ? icon_nav3.active : icon_nav3.normal" style="width: 25px;height: 25px;" />
      {{$t('home.tabBar[3]')}}
    </van-tabbar-item>
    <van-tabbar-item to="/user" name="user">
      <img slot="icon" slot-scope="props" :src="props.active ? icon_nav5.active : icon_nav5.normal" style="width: 25px;height: 25px;" />
      {{$t('home.tabBar[4]')}}
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  name: 'Footer',
  components: {

  },
  props: [],
  data() {
    return {
      tabbarIndex: this.$route.matched[0].meta.active,
      icon_nav1: {
        normal: "./static/images/bar/index.png",
        active: "./static/images/bar/index_select.png"
      },
      icon_nav2: {
        normal: "./static/images/bar/task.png",
        active: "./static/images/bar/task_select.png"
      },
      icon_nav3: {
        normal: "./static/images/bar/profit.png",
        active: "./static/images/bar/profit_select.png"
      },
      icon_nav4: {
        normal: "./static/images/bar/vip.png",
        active: "./static/images/bar/vip_select.png"
      },
      icon_nav5: {
        normal: "./static/images/bar/mine.png",
        active: "./static/images/bar/mine_select.png"
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>


<style scoped>
.van-tabbar {
  height: 52px;
  background: #fff;
}
.van-tabbar-item__icon {
  font-size: 24px;
  z-index: 999;
}
.van-tabbar-item__icon img{
  height: 30px;
}
.van-tabbar-item__icon .addTask{
  height: 72px;
  margin: -38px 0 -10px;
}
.van-tabbar-item {
  color: #000!important;
}

.van-tabbar-item--active{
  background:#fff!important;
  color: #37774C !important;
}
.Site .van-tabbar-item__text{
  color: #37774C;
}
/*.vip ::v-deep .van-tabbar-item__icon{
	height: 50px;
    width: 50px;
    background-color: #fff;
    border-radius: 50%;
    display: block;
    overflow: hidden;
    margin: 0 auto;
	}*/
</style>